import { makeAutoObservable, runInAction } from 'mobx'

import downloadRequestService from '@services/downloadCenter/downloadRequestService'
import type {
  DownloadRequestDto,
  DownloadRequestFilter,
} from '@models/downloadCenter/downloadRequest'

/**
 * State dùng chung của Download Request Center.
 *
 * Chỉ còn phục vụ BẢNG QUẢN TRỊ ở `/download-center`. Phần drawer "Yêu cầu tải của tôi" (cờ
 * `drawerVisible` + `recentItems` + `loadRecent`) đã bị bỏ cùng với drawer: nội dung đó giờ là tab
 * trong `/my-pending-tasks`, và tab tự quản state của nó trong `MyDownloadRequestsList` — không có
 * nơi thứ hai nào cần đọc nên không cần nâng lên store.
 *
 * ⚠️ **Lệch có chủ ý so với quy ước "luôn dùng @inject" trong `UI/Portal/CLAUDE.md`.** Store này
 * export thêm một singleton. Đúng tiền lệ `appDataStoreInstance` đang có trong repo. Store vẫn được
 * đăng ký ở `storeInitializer` để component nào muốn `@inject` vẫn dùng được.
 */
export class DownloadRequestStore {
  items: DownloadRequestDto[] = []
  totalCount = 0
  loadingList = false

  constructor() {
    makeAutoObservable(this)
  }

  loadList = async (filter: DownloadRequestFilter) => {
    this.loadingList = true
    try {
      const result = await downloadRequestService.getAll(filter)
      runInAction(() => {
        this.items = result?.items ?? []
        this.totalCount = result?.totalCount ?? 0
      })
    } finally {
      runInAction(() => {
        this.loadingList = false
      })
    }
  }
}

export default DownloadRequestStore

const downloadRequestStoreInstance = new DownloadRequestStore()
export { downloadRequestStoreInstance }
